import React, { createContext, useContext } from "react";
import {
  useAiMetricsFilters,
  AiMetricsFilters,
} from "../hooks/useAiMetricsFilters";

interface IAiMetricsProviderProps {
  storageKey: string;
  children: React.ReactNode;
}

const AiMetricsContext = createContext<AiMetricsFilters | null>(null);

export const AiMetricsProvider = ({
  storageKey,
  children,
}: IAiMetricsProviderProps): JSX.Element => {
  const filters = useAiMetricsFilters(storageKey);
  return (
    <AiMetricsContext.Provider value={filters}>
      {children}
    </AiMetricsContext.Provider>
  );
};

export const useAiMetrics = (): AiMetricsFilters => {
  const ctx = useContext(AiMetricsContext);
  if (!ctx)
    throw new Error("useAiMetrics must be used within AiMetricsProvider");
  return ctx;
};
